// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"32":"c7cb5095","293":"c7cb5095","402":"c7cb5095","795":"c7cb5095","848":"9253c086","926":"3c4fa657"}[chunkId] + ".css";
};